import useFieldState from "../../../hooks/useFieldState";
import useForm from "../../../hooks/useForm";
import { useWizard } from "../../../hooks/useWizard";
import { DropdownInput } from "../../Form/DropdownInput";
import { ModalContentContainer, ModalBody, ModalSection, ModalFooter } from "../../Modal/index";

export const YearSelector = () => {
    const [{ year }] = useFieldState();
    const { register, setValue } = useForm();
    const {error} = useWizard();

    return (
      <ModalContentContainer>
        <ModalBody title="Which year would you like to view or download data for?">
          <ModalSection styles="h-full">
            <p className=" text-sm sm:text-xl sm:w-4/5 py-5">
            Compliance data are reported a year behind the calendar year and published by the end of September.  
            </p>
          </ModalSection>
          <ModalSection styles="flex content-center flex-wrap">
            <DropdownInput
              displayError={error}
              errorMessage="Please select the year."
              label="Select the year"
              name="year"
              options={year.map((y) => ({ value: y.id, label: y.name }))}
              ref={register}
              setValue={setValue}
              styles={{
                container: "w-full sm:w-1/3 sm:pb-6",
                label: "text-sm sm:text-3xl font-bold",
                dropdown: "mt-2",
                error: "text-red-600 font-xs h-5"
              }}
            />
          </ModalSection>
        </ModalBody>
        <ModalFooter currentFormValue="year" />
      </ModalContentContainer>
    );
  };